/**
 * <featured-recipe-stack> — cycles through featured recipe cards one at a time,
 * showing the active card tilted in front and the next card peeking out behind it
 * (Figma "Featured Recipe Block": front card rotated -3deg, next card offset behind).
 * Only two layers are ever visible regardless of how many cards are tagged "featured".
 */
class FeaturedRecipeStack extends HTMLElement {
  connectedCallback() {
    this.cards = Array.from(this.querySelectorAll('.featured-recipe-stack__card'));
    this.index = 0;
    this.prevBtn = this.querySelector('.featured-recipe-stack__arrow--prev');
    this.nextBtn = this.querySelector('.featured-recipe-stack__arrow--next');

    this.prevBtn?.addEventListener('click', () => this.advance(-1));
    this.nextBtn?.addEventListener('click', () => this.advance(1));

    this.render();
  }

  advance(direction) {
    const count = this.cards.length;
    if (count === 0) return;
    // Clamped, not wrapped: stops at the first/last card instead of cycling back around, so
    // the prev/next buttons can reach a real "end" and disable themselves there.
    this.index = Math.min(Math.max(this.index + direction, 0), count - 1);
    this.render();
  }

  render() {
    const count = this.cards.length;

    this.cards.forEach((card, i) => {
      card.classList.remove('is-front', 'is-peek', 'is-hidden');
      card.setAttribute('aria-hidden', i === this.index ? 'false' : 'true');

      if (i === this.index) {
        card.classList.add('is-front');
      } else if (i === this.index + 1) {
        card.classList.add('is-peek');
      } else {
        card.classList.add('is-hidden');
      }
    });

    const hasMultiple = count > 1;
    if (this.prevBtn) {
      this.prevBtn.hidden = !hasMultiple;
      this.prevBtn.disabled = this.index === 0;
    }
    if (this.nextBtn) {
      this.nextBtn.hidden = !hasMultiple;
      this.nextBtn.disabled = this.index === count - 1;
    }
  }
}

if (!customElements.get('featured-recipe-stack')) {
  customElements.define('featured-recipe-stack', FeaturedRecipeStack);
}
